import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobCreatePage from '@/features/jobs/job-create/JobCreatePage';

export const jobCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/nova',
  component: JobCreatePage,
});
